/**
 * Human-readable entity keys. Internal identifiers are UUIDv7; these keys are
 * what the user sees and what appears in URLs (see ADR-5).
 */
export const projectCodePattern = /^[A-Z][A-Z0-9]{1,9}$/;
export const formatCaseKey = (projectCode, seq) => `${projectCode}-${seq}`;
export const formatChecklistKey = (projectCode, seq) => `${projectCode}-CHK-${seq}`;
export const formatRunKey = (projectCode, seq) => `${projectCode}-RUN-${seq}`;
const CASE_KEY = /^([A-Z][A-Z0-9]{1,9})-(\d+)$/;
const CHECKLIST_KEY = /^([A-Z][A-Z0-9]{1,9})-CHK-(\d+)$/;
const RUN_KEY = /^([A-Z][A-Z0-9]{1,9})-RUN-(\d+)$/;
const parse = (pattern, value) => {
    const match = pattern.exec(value.trim().toUpperCase());
    if (!match?.[1] || !match[2])
        return null;
    return { projectCode: match[1], seq: Number(match[2]) };
};
export const parseCaseKey = (value) => parse(CASE_KEY, value);
export const parseChecklistKey = (value) => parse(CHECKLIST_KEY, value);
export const parseRunKey = (value) => parse(RUN_KEY, value);
//# sourceMappingURL=keys.js.map